import React from 'react';
import styled from '@emotion/styled';
import AdditionalAdBannerSource from 'components/ads/AdditionalAdBannerSource';
import { AdGetter } from 'components/ads/types';
import ProjectAdBanner from 'components/ads/ProjectAdBanner';
import { useScreenBreakpoint } from 'consts/breakpoints';

const Wrapper = styled.div`
  padding: ${({ theme }) => `${theme.spacing(2)} ${theme.spacing(3)}`};
`;

export const BannerSticky: React.FC<{ isOpen: boolean }> = ({ isOpen }) => {
  const screen = useScreenBreakpoint();

  if (screen > 2 || !isOpen) return null;

  return (
    <Wrapper>
      <AdditionalAdBannerSource>
        {(getAdditionalBanner: AdGetter) => (
          <ProjectAdBanner
            eventSource="unit_page_additional_banner"
            ad={getAdditionalBanner()}
            mTop={1}
            height="auto"
            fullWidth
          />
        )}
      </AdditionalAdBannerSource>
    </Wrapper>
  );
};
